import { render, staticRenderFns } from "./history-result-pdf.vue?vue&type=template&id=883d3fb6&"
import script from "./history-result-pdf.vue?vue&type=script&lang=js&"
export * from "./history-result-pdf.vue?vue&type=script&lang=js&"
import style0 from "./history-result-pdf.vue?vue&type=style&index=0&id=883d3fb6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports